export class User {
    firstName: string = '';
    lastName: string = '';
    username: string = '';
    email: string = '';
    phone: string = '';
    orgId: number = 0;
    userId: number = 0;
    roleId: number = 0;
}
